import { defineStore } from 'pinia'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { ref,reactive } from 'vue'


export const useSettingStore = defineStore('SettingStore', {
    state: () => {
        const $route = useRoute(),
        $router = useRouter(),
        filePickerCallback = (cb, value, meta) => {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.addEventListener('change', (e) => {
                const file = e.target.files[0],
                route = $router.resolve(
                    {
                        name: 'upload-images'
                    }
                );
                let fd= new FormData()
                fd.append('image', file)
                axios.post(route.href, fd)
                .then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    cb(response.data.data.image_url, { title: file.name });
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            });
            input.click();
        };
        return {
            setting: {
                routes: null,
            },
            thumbnail: 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/creditfixrr-pdf.png',
            creditfixrrBanner: 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/banners/creditfixrr.jpg',
            logo: 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/creditfixrr.jpg',
            favicon: 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/favicon.ico',
            modalLogo: 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/creditfixrr-dot-com-logo.png',
            defaultBanner: 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/dispute-center-images/creditfixrr.com.png',
            clicksend: {
                baseurl: 'https://rest.clicksend.com/v3',
                signup: 'https://clicksend.com/?u=253180',
                pricing: 'https://www.clicksend.com/us/pricing/us/#fax',
                fax_numbers: 'https://dashboard.clicksend.com/numbers/fax',
                clicksend_username: null,
                clicksend_password: null,
                clicksend_fax_number: null,
            },
            trial: {
                enable_popup: null,
                enable_banner: null
            },
            dashboardBanner: ref(null),
            isSettingFetched: false,
            gohighlevel_clients:reactive(),
            route: useRoute(),
            router: useRouter(),
            payment: {
                precision: 2
            },
            tinymce: {
                api_key: process.env.MIX_TINYMCE_API_KEY,
                configuration: {
                    height: 500,
                    menubar: false,
                    plugins: 'advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime media table casechange directionality advcode visualchars mediaembed codesample pagebreak nonbreaking tableofcontents wordcount editimage help formatpainter permanentpen emoticons advtable export autosave',
                    automatic_uploads: true,
                    toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                    content_style: '.letter-content-background { background-color: yellow; } body { font-size: 10pt; font-family: times new roman, times, serif } .text-danger { color: #ea5455 !important; } #footer .page { display: none; }  .text-red { color: red; } .text-white { color: white; } .text-orange { color: orange; } .text-light-blue { color: #00A6CA; } .text-purple { color: purple; } .bg-light-blue { background: #00A6CA; } .bg-dark-blue { background: #1d4f91; } .bg-light-red { background: #981e32; } .bg-light-grey { background: #f7f7f7; } .bg-yellow { background: yellow; } .border-bottom-1 { border-bottom: 1px solid; } .column-active { border: 2px solid black; background-color: darkgreen; color: white; } .column-focus { border: 1px solid red; border-radius: 100%; }',
                    file_picker_callback: filePickerCallback,
                    valid_elements : '*[*]',
                    extended_valid_elements: '*[*]',
                    valid_children : '+body[style]',
                    forced_root_block: 'p',
                    keep_styles: false,
                    newline_behavior: 'linebreak',
                },
            },
            tour_setup : reactive({
                viewTour:ref(),
                append_tour_control:ref(),
                step_name : ref(),
                start_status : 'started',
                hidden_status : 'hidden',
                not_complete : 'not_complete',
                completed : 'completed',
                pause : 'pause',
            }),
            isAiDialogVisible:ref(false)
        }
    },
    // persist: true,
    actions: {
        async fetchSetting() {
            try {
                const $this = this,
                route = $this.router.resolve(
                    {
                        name: 'default-settings'
                    }
                );
                await axios.get(route.href)
                .then(function (response) {
                    if (response.data.error == true) {
                        // setTimeout(() => {
                        //     toastr.error(response.data.message, 'Error!');
                        // }, 2000)
                        // console.log(response.data);
                        return;
                    }
                    $this.setting.routes = response.data.data.routes;
                    $this.clicksend.clicksend_username = response.data.data.clicksend.clicksend_username;
                    $this.clicksend.clicksend_password = response.data.data.clicksend.clicksend_password;
                    $this.clicksend.clicksend_fax_number = response.data.data.clicksend.clicksend_fax_number;
                    $this.trial.enable_popup = response.data.data.trial.enable_popup;
                    $this.trial.enable_banner = response.data.data.trial.enable_banner;
                    $this.isDashboardBannerEnable = response.data.data.enable_dashboard_banner;
                    $this.dashboardBanner = response.data.data.dashboard_banner;
                    $this.isSettingFetched = true;
                    $this.gohighlevel_clients = response.data.data.gohighlevel_client;

                });
            } catch (error) {
                console.log(error);
            }
        },
        updateFaxSetting() {
            const $this = this,
            route = $this.router.resolve(
                {
                    name: 'fax-setting'
                }
            );
            axios.put(
                route.href,
                {
                    clicksend_username: $this.clicksend.clicksend_username,
                    clicksend_password: $this.clicksend.clicksend_password,
                    clicksend_fax_number: $this.clicksend.clicksend_fax_number
                }
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        },
        updateFaxNumber(faxNumber) {
            this.clicksend.clicksend_fax_number = faxNumber;
        },
        setTourComponent(component) {
            this.tour_setup.append_tour_control = component;
        },
    },
    getters: {
        getSetting: (state) => {
            return () => {
                return state.setting;
            }
        },
        getUrl: (state) => {
            return (path) => {
                return state.clicksend.baseurl + path;
            }
        },
        isClicksendUpdated: (state) => {
            return !_.isNull(state.clicksend.clicksend_username) && !_.isNull(state.clicksend.clicksend_password);
        }
    },
})
